export const HARDCODED_PRIORITY_CHAIN_IDS_FOR_NETWORK_SELECTOR: number[] = [];
